import '../styles/booking.css';
import { LanguageSwitcher } from '../components/LanguageSwitcher.js';

/**
 * Страница для локальной разработки: открывается на http://localhost:5174/
 * когда хост не m*.beclients.ru. Подсказывает, как открыть веббукинг с локальным API.
 */
export default function DevHelpPage() {
  const base = typeof window !== 'undefined' ? window.location.origin : '';
  const exampleUrl = `${base}/booking/5472`;

  return (
    <div className="booking-container" style={{ textAlign: 'center', maxWidth: 480, margin: '2rem auto', padding: '0 1rem' }}>
      <div className="booking-card" style={{ padding: '1.5rem' }}>
        <div className="booking-card-lang-row">
          <LanguageSwitcher />
        </div>
        <h1 className="booking-title" style={{ marginBottom: '1rem', fontSize: '1.25rem' }}>
          Веббукинг — локальная разработка
        </h1>
        <p style={{ color: 'var(--color-text-muted)', marginBottom: '1rem', textAlign: 'left' }}>
          <strong>Localhost:</strong> честный короткий URL — <code style={{ background: 'var(--color-bg)', padding: '0.2rem 0.4rem', borderRadius: 4 }}>/?code=5472</code> (подставьте свой publicCode). Или полный путь:
        </p>
        <p style={{ marginBottom: '0.5rem', textAlign: 'left' }}>
          <strong>URL:</strong>{' '}
          <code style={{ background: 'var(--color-bg)', padding: '0.2rem 0.4rem', borderRadius: 4 }}>
            /booking/ВАШ_PUBLIC_CODE
          </code>
        </p>
        <p style={{ marginBottom: '1rem', fontSize: '0.9rem', color: 'var(--color-text-muted)', textAlign: 'left' }}>
          Пример: <a href={exampleUrl}>{exampleUrl}</a> или <a href={`${base}/?code=5472`}>{base}/?code=5472</a>
        </p>
        <p style={{ marginBottom: '1rem', fontSize: '0.9rem', color: 'var(--color-text-muted)', textAlign: 'left' }}>
          <strong>DEV</strong> (booking-dev.beclients.ru): корень <code>/</code> уже показывает запись (честный URL). После деплоя откройте <code>{'https://booking-dev.beclients.ru/booking/<slug>'}</code>.
        </p>
        <p style={{ marginBottom: '0.5rem', textAlign: 'left', fontSize: '0.9rem' }}>
          <strong>Что проверить:</strong>
        </p>
        <ul style={{ textAlign: 'left', margin: '0 0 1rem 1.25rem', paddingLeft: 0, color: 'var(--color-text-muted)', fontSize: '0.9rem' }}>
          <li>Backend запущен (например на <code>http://localhost:3000</code>)</li>
          <li>В <code>web-booking/.env.local</code>: <code>VITE_API_URL=http://localhost:3000</code></li>
          <li>В базе есть мастер с таким <code>publicCode</code> и включённой онлайн-записью</li>
        </ul>
        <p style={{ fontSize: '0.85rem', color: 'var(--color-text-muted)', textAlign: 'left' }}>
          Ссылку «Открыть запись» в настройках web-master на localhost задайте в <code>VITE_BOOKING_URL_TEMPLATE</code>, например:{' '}
          <code>http://localhost:5174/booking/{'{code}'}</code>.
        </p>
      </div>
    </div>
  );
}
